import React, { Component } from 'react'
import { Form, FormGroup, ControlLabel } from 'react-bootstrap'
import DatePicker from 'component/element/DatePicker'
class EMDatePicker extends Component {

    constructor(...args) {
      super(...args)
      this.state = {}
      
    }

    onFormChange(e) {
        this.props.onChange(e)
    }

    render() {
        let {formData,schema,required} = this.props
        return(
            <Form>
                <FormGroup>
                    <ControlLabel>{schema.title}{required?<span className='text-red'>*</span>:''}</ControlLabel>
                    <DatePicker 
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={formData}
                        onChange={this.onFormChange.bind(this)}
                        maxWidth={'100%'}
                    />
                </FormGroup>
            </Form>    
        )
    }    
}    
export default EMDatePicker


// WEBPACK FOOTER //
// ./src/view/hr/employee/EMDatePicker.js